
export const API_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : '';

export const REGISTERED_SERVERS = [
    ...[1,2,3,4,5,6,7].map(x => `fr${x}.mclloyd.com`),
    ...[1,2,3].map(x => `hh${x}.mclloyd.com`),
    ...[1].map(x => `za${x}.mclloyd.com`),
    ...[1].map(x => `wd${x}.mclloyd.com`),
    'sav.mclloyd.com',
];

export const REGISTERED_PORTS = [32768, 20005];
